import { createContext, useState } from "react";

export const MenuContext = createContext();

const MenuProvider = ({ children }) => {
  const isMenuOpen = localStorage.getItem("menuOpen");
  const isMenuOpenParsed = JSON.parse(isMenuOpen);

  const [open, setOpen] = useState(
    isMenuOpenParsed === null ? true : isMenuOpenParsed
  );

  const handleToggleMenu = () => {
    setOpen(!open);
    localStorage.setItem("menuOpen", !open);
  };

  return (
    <MenuContext.Provider value={{ open, handleToggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export default MenuProvider;
